import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { api } from '../../lib/api.ts'
import { useBootstrap } from '../../lib/catalog.ts'
import { useT } from '../../lib/i18n.tsx'
import { useCustomFields } from '../admin/custom-field-data.ts'
import { rotuloCampo } from './campos-shared.tsx'
import { catalogoDeColunas } from './colunas-da-tabela.ts'

/**
 * O catálogo de colunas da lista de Itens: as do item, uma por campo
 * complementar (SPEC-20261006-1057-colunas-da-lista) e as da TRILHA, com
 * checkbox, por etapa de fluxo e por status (SPEC-20261007-2155-trilha-de-etapas-e-status).
 *
 * Fora da tela desde a SPEC-20261103-1217: o editor de filtro (da lista e do
 * quadro) escolhe as colunas do filtro neste mesmo catálogo — dois catálogos
 * divergiriam na primeira coluna nova.
 */
export function useCatalogoDeColunas() {
  const camposComplementares = useCustomFields('work_item')
  const t = useT()
  const bootstrap = useBootstrap()
  const nosDeFluxo = useQuery({
    queryKey: ['flow-nodes'],
    queryFn: async () => (await api.flows.nodes.$get()).json(),
    // plano sem fluxos responde erro: a lista segue sem as colunas de etapa
    retry: false,
  })
  const catalogo = useMemo(
    () =>
      catalogoDeColunas(
        (camposComplementares.data?.fields ?? []).map((f) => ({
          key: f.key,
          rotulo: rotuloCampo(f.labels, f.key),
        })),
        {
          etapas: (
            (nosDeFluxo.data?.nodes ?? []) as {
              flowStepId: string
              stepName: string
              flowName: string
            }[]
          ).map((n) => ({
            id: n.flowStepId,
            rotulo: `${n.stepName} (${n.flowName})`,
          })),
          status: (bootstrap.data?.workItemStatuses ?? [])
            .filter((s) => s.isActive)
            .map((s) => {
              const nome = s.nameTranslationKey ? t(s.nameTranslationKey) : ''
              return {
                id: s.id,
                rotulo: nome && nome !== s.nameTranslationKey ? nome : s.code,
              }
            }),
        },
      ),
    [camposComplementares.data, nosDeFluxo.data, bootstrap.data, t],
  )
  /** Algum cadastro das colunas ainda em voo: não descarta colunas guardadas. */
  const catalogoIncompleto = !camposComplementares.data || nosDeFluxo.isPending || !bootstrap.data
  return { catalogo, catalogoIncompleto, camposComplementares, nosDeFluxo }
}
